import { render } from "./ManageScreen.vue?vue&type=template&id=50918109"
import script from "./ManageScreen.vue?vue&type=script&lang=js"
export * from "./ManageScreen.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html2/esmanage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__